import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { VacanteFiltros, VacantesService } from 'src/app/services/vacante/vacantes.service';
import { Vacante, VacanteDTO } from 'src/app/interfaces/vacantes';
import { environment } from 'src/environments/environment';
import { construirUrlArchivo } from 'src/app/utils/imagen-url.util';
import { ActivatedRoute, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { RolesType } from 'src/app/enums/RolesType.enum';
import { ModalMessageComponent } from '../../common/modalmessage/modalmessage.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject, throwError } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { InicioService } from 'src/app/services/inicio/inicio.service';
import { Categorias } from 'src/app/interfaces/categorias';
import { Buscador } from 'src/app/interfaces/inicio';

@Component({
  selector: 'app-job-list',
  templateUrl: './job-list.component.html',
  styleUrls: ['./job-list.component.scss']
})
export class JobListComponent implements OnInit, OnDestroy {

  usuario: JwtResponse;
  usuarioRol: string;
  vacantes: Vacante[];
  vacantesComunidad: Vacante[] = [];
  cantidadVacantes: number;
  noPagina: number;
  totalItems: number = 0;
  verArchivos: string;

  formFilter: FormGroup;
  categorias: Categorias[];
  categoriaSeleccionada: number = 0;
  paises: string[] = [];
  tiposContrato: string[] = [];
  modalidadesEmpleo: any[] = [];
  mensajeError: string;
  cargando: boolean;

  vacantesDto: VacanteDTO[];

  duplicando = false;

  private destroy$ = new Subject<void>();

  constructor(private title: Title, private meta: Meta, private vacantesService: VacantesService,
    private router: Router, @Inject(PLATFORM_ID) private platformId: object, private modalService: NgbModal,
    private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private inicioService: InicioService) {
    this.usuario = JSON.parse(localStorage.getItem('currentUser'));
    this.usuarioRol = '';
    this.agregarMetaData();
    this.noPagina = 1;
    this.cantidadVacantes = 10;
    this.obtenerCategorias()
    this.obtenerPaises()
    this.obtenerTiposContrato()
    this.obtenerModalidadesEmpleo()
    this.verArchivos = environment.baseArchivos;
    this.cargando = false;
  }

  ngOnInit(): void {
    this.crearForm();

    const qp = this.activatedRoute.snapshot.queryParams;
    this.noPagina = qp.pagina ? (parseInt(qp.pagina, 10) || 1) : 1;

    // Estado propio de búsqueda (persistido por actualizarQueryParams al buscar/paginar).
    // "titulo" es el nombre que manda el buscador del home (home.component.ts buscarVacante()).
    const q = qp.q || qp.buscar || qp.titulo || null;
    const pais = qp.pais || null;
    const catId = qp.catId ? Number(qp.catId) : null;
    const tipoContrato = qp.tipoContrato || null;
    const idModalidadEmpleo = qp.modalidad ? Number(qp.modalidad) : null;
    // Legacy: enlaces externos (ej. tg-sitio) que mandan ?categoria=NombreCategoria a un endpoint distinto
    const categoriaLegacy = qp.categoria;
    const empresa = qp.empresa;

    if(this.usuario){
      this.usuarioRol = this.usuario.role;
      if(this.usuarioRol === RolesType.EMPRESAS){
        this.obtenerListaVacantesPorIdEmpresa(this.usuario.user.idUsuario, this.usuarioRol);
        return;
      }
    }

    if(empresa){
      this.obtenerVacantesPorEmpresa(empresa);
    } else if(categoriaLegacy && !q && !pais && !catId && !tipoContrato && !idModalidadEmpleo){
      this.obtenerVacantesPorCategoria(categoriaLegacy);
      // Intentar resaltar la categoría en las píldoras (si ya cargaron)
      this.resaltarCategoriaPorNombre(categoriaLegacy);
    } else if(q || pais || catId || tipoContrato || idModalidadEmpleo){
      this.categoriaSeleccionada = catId || 0;
      this.formFilter.patchValue({
        tituloVacante: q, pais: pais, categoria: catId || 0,
        tipoContrato: tipoContrato, idModalidadEmpleo: idModalidadEmpleo || 0
      }, { emitEvent: false });
      this.buscador(false);
    } else {
      this.obtenerListaVacantes(null);
    }

    this.suscribirBusquedaAutomatica();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Previene llamadas concurrentes al API mientras una búsqueda está en vuelo
  private buscando = false;

  /** Búsqueda intuitiva estilo Skyscanner: cambiar cualquier filtro busca solo, sin obligar a dar clic en "Buscar". */
  private suscribirBusquedaAutomatica(): void {
    // Solo en navegador: en SSR no hay interacción de usuario y valueChanges no es útil
    if (!isPlatformBrowser(this.platformId)) return;

    this.formFilter.valueChanges.pipe(
      distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
      debounceTime(400),
      takeUntil(this.destroy$)
    ).subscribe(() => this.buscador(true));
  }
  private agregarMetaData(): void {
    this.title.setTitle('Vacantes');
    this.meta.updateTag({name: "description", content: "¿Estás buscando trabajo? Regístrate y conoce las vacantes que tenemos para ti en PHP, JAVA, Xamarin, Angular, Javascript, etc. ¡Regístrate de manera gratuita!"});//falta descripcion e imagen para mostrar en open graph
    this.meta.updateTag({name: "keywords", content: "registro, empresas, postulaciones, vacantes, salario, programador"});
    this.meta.updateTag({name: "robots", content: "noodp"});
    this.meta.updateTag({property: "og:title", content: "Vacantes"});
    this.meta.updateTag({property: "og:description", content: "¿Estás buscando trabajo? Regístrate y conoce las vacantes que tenemos para ti en PHP, JAVA, Xamarin, Angular, Javascript, etc. ¡Regístrate de manera gratuita!"});
    this.meta.updateTag({property: "og:url", content: environment.baseTG});
    this.meta.updateTag({property: "og:site_name", content: "TG Empleos"});
    this.meta.updateTag({property: "og:locale", content: "es_ES"});
    this.meta.updateTag({property: "og:type", content: "website"});
    this.meta.updateTag({property: "og:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:title", content: "Vacantes"});
    this.meta.updateTag({name: "twitter:description", content:"¿Estás buscando trabajo? Regístrate y conoce las vacantes que tenemos para ti en PHP, JAVA, Xamarin, Angular, Javascript, etc. ¡Regístrate de manera gratuita!"});
    this.meta.updateTag({name: "twitter:site", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:creator", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:card", content: "summary"});
  }

  crearForm(){
    this.formFilter = this.formBuilder.group({
        tituloVacante: [null],
        pais: [null],
        categoria: [0],
        tipoContrato: [null],
        idModalidadEmpleo: [0]
    });
  }

  async obtenerCategorias(){
    try {
      const response = await this.inicioService.obtenerCategoriasEmpresas();
      this.categorias = response.data;
    } catch (error) {
      console.error("Error al obtener las categorías", error);
    }
  }

  async obtenerPaises(){
    try {
      this.paises = await this.vacantesService.getPaises();
    } catch (error) {
      console.error("Error al obtener países", error);
    }
  }

  async obtenerTiposContrato(){
    try {
      this.tiposContrato = await this.vacantesService.getTiposContrato();
    } catch (error) {
      console.error("Error al obtener tipos de contrato", error);
    }
  }

  async obtenerModalidadesEmpleo(){
    try {
      this.modalidadesEmpleo = await this.vacantesService.getModalidadesEmpleoPublicas();
    } catch (error) {
      console.error("Error al obtener modalidades de empleo", error);
    }
  }

  async buscador(actualizarUrl: boolean = true){
    // Evitar llamadas concurrentes que pisen resultados
    if (this.buscando) return;
    this.buscando = true;
    this.cargando = true;
    const formValue = this.formFilter.value;

    // Sincronizar el resaltado de píldoras con el valor real del formulario
    // (cubre tanto clicks en píldoras como cambios en el <select>)
    this.categoriaSeleccionada = formValue.categoria || 0;

    const filtros: VacanteFiltros = {
        q: formValue.tituloVacante || undefined,
        pais: formValue.pais || undefined,
        categoria: formValue.categoria != 0 ? formValue.categoria : undefined,
        tipoContrato: formValue.tipoContrato || undefined,
        idModalidadEmpleo: formValue.idModalidadEmpleo != 0 ? formValue.idModalidadEmpleo : undefined
    };

    if (actualizarUrl) this.noPagina = 1;
    try {
        await this.cargarPagina(filtros);
        this.mensajeError = this.vacantes.length === 0
          ? "Lo sentimos no hay vacantes existentes con esos criterios."
          : "";
        if (actualizarUrl) this.actualizarQueryParams();
    } catch (error) {
        console.error("Error al traer vacantes del buscador", error);
        this.mensajeError = "Ocurrió un error al buscar. Intenta de nuevo.";
    } finally {
        this.cargando = false;
        this.buscando = false;
    }
  }

  /** Trae la página actual (filtro + noPagina) desde el servidor — paginación/filtrado/orden reales, no en el cliente. */
  private async cargarPagina(filtros: VacanteFiltros): Promise<void> {
    const response: any = await this.vacantesService.obtenerVacantesPaginadas(filtros, this.noPagina - 1, this.cantidadVacantes);
    const paged = response.data;
    this.vacantes = paged?.content ?? [];
    // Vacantes de comunidad ya no se mezclan con vacantes normales
    this.vacantesComunidad = [];
    this.totalItems = paged?.totalElements ?? 0;
    this.vacantes.forEach(vacante => {
      vacante.logo = construirUrlArchivo(vacante.logo, environment.empresaDefault);
    });
  }

  /** Refleja el filtro/página actual en la URL para que "Regresar" desde el detalle restaure la misma búsqueda. */
  private actualizarQueryParams(): void {
    const formValue = this.formFilter?.value || {};
    const queryParams: any = { pagina: this.noPagina };
    if (formValue.tituloVacante) queryParams.q = formValue.tituloVacante;
    if (formValue.pais) queryParams.pais = formValue.pais;
    if (formValue.categoria && formValue.categoria != 0) queryParams.catId = formValue.categoria;
    if (formValue.tipoContrato) queryParams.tipoContrato = formValue.tipoContrato;
    if (formValue.idModalidadEmpleo && formValue.idModalidadEmpleo != 0) queryParams.modalidad = formValue.idModalidadEmpleo;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams,
      replaceUrl: true
    });
  }

  async onPageChange(page: number): Promise<void> {
    if (this.buscando) return;
    this.buscando = true;
    this.noPagina = page;
    this.cargando = true;
    try {
      const formValue = this.formFilter.value;
      await this.cargarPagina({
        q: formValue.tituloVacante || undefined,
        pais: formValue.pais || undefined,
        categoria: formValue.categoria != 0 ? formValue.categoria : undefined,
        tipoContrato: formValue.tipoContrato || undefined,
        idModalidadEmpleo: formValue.idModalidadEmpleo != 0 ? formValue.idModalidadEmpleo : undefined
      });
      this.actualizarQueryParams();
    } catch (error) {
      console.error("Error al paginar vacantes.", error);
      this.mensajeError = "Ocurrió un error al cambiar de página. Intenta de nuevo.";
    } finally {
      this.cargando = false;
      this.buscando = false;
    }
  }

  /** Limpia todos los filtros de una vez (el propio valueChanges dispara la búsqueda automática). */
  limpiarFiltros(): void {
    this.categoriaSeleccionada = 0;
    this.formFilter.reset({ tituloVacante: null, pais: null, categoria: 0, tipoContrato: null, idModalidadEmpleo: 0 });
  }

  /** Selecciona una categoría desde las píldoras rápidas (igual que en inicio). */
  seleccionarCategoria(catId: number): void {
    // Si ya está seleccionada, la deselecciona (toggle)
    if (this.categoriaSeleccionada === catId) {
      this.categoriaSeleccionada = 0;
      this.formFilter.patchValue({ categoria: 0 });
    } else {
      this.categoriaSeleccionada = catId;
      // Limpiar el campo de búsqueda para que la búsqueda sea solo por categoría,
      // evitando combinar un keyword previo con la nueva categoría (0 resultados).
      this.formFilter.patchValue({ tituloVacante: null, categoria: catId });
    }
    // valueChanges se encarga de disparar buscador(true) automáticamente
  }

  /** Intenta resaltar la píldora de categoría por nombre (para URLs legacy ?categoria=Nombre). */
  private resaltarCategoriaPorNombre(nombre: string): void {
    if (!nombre || !this.categorias?.length) return;
    const cat = this.categorias.find(c =>
      c.nombreCategoria?.toLowerCase() === nombre.toLowerCase());
    if (cat) {
      this.categoriaSeleccionada = cat.idCategoria;
    }
  }

  get hayFiltrosActivos(): boolean {
    const v = this.formFilter?.value || {};
    return !!(v.tituloVacante || v.pais || (v.categoria && v.categoria != 0) || v.tipoContrato || (v.idModalidadEmpleo && v.idModalidadEmpleo != 0));
  }

  async obtenerListaVacantes(buscar: string){
    this.cargando = true;
    try {
      await this.cargarPagina({ q: buscar || undefined });
    } catch (error) {
      console.error("Error al obtener los vacantes.", error);
    } finally {
      this.cargando = false;
    }

  }




  async obtenerVacantesPorCategoria(categoria: string){
    this.cargando = true;
    try {
      const response = await this.vacantesService.obtenerVacantesPorCategoria(categoria);
      this.vacantes = response.data;
      if(this.vacantes){
        this.vacantes.forEach(vacante => {
          vacante.logo = construirUrlArchivo(vacante.logo, environment.empresaDefault);
        });
      }
    } catch (error) {
      console.error("Error al obtener los vacantes por categoría.", error);
    } finally {
      this.cargando = false;
    }
  }


  async obtenerVacantesPorEmpresa(empresa: number){
    this.cargando = true;
    try {
      const response = await this.vacantesService.obtenerVacantesFiltroPorEmpresa(empresa);
      this.vacantes = response.data;
      if(this.vacantes){
        this.vacantes.forEach(vacante => {
          vacante.logo = construirUrlArchivo(vacante.logo, environment.empresaDefault);
        });
      }
    } catch (error) {
      console.error("Error al obtener los vacantes por empresa.", error);
    } finally {
      this.cargando = false;
    }
  }

  async obtenerListaVacantesPorIdEmpresa(idEmpresa: number, rol: string){
    this.cargando = true;
    try {
      const response = await this.vacantesService.obtenerVacantesPorIdEmpresa(idEmpresa, rol);
      this.vacantes = response.data;
      if(this.vacantes){
        this.vacantes.forEach(vacante => {
          vacante.logo = construirUrlArchivo(vacante.logo, environment.empresaDefault);
        });
      }
    } catch (error) {
      console.error("Error al obtener los vacantes por la empresa.", error);
    } finally {
      this.cargando = false;
    }
  }

  editarVacante(idVacante: number): void{
    localStorage.setItem('idVacante', idVacante.toString());
    if(localStorage.getItem('idVacante')){
      this.router.navigate(['/vacante/editar']);
    }
  }

  async duplicarVacante(idvacante) {
    try {
      this.duplicando = true;
      const response = await this.vacantesService.obtenerDetallesVacante(idvacante, null);
      const vacante: VacanteDTO = response.data;
      if(vacante != null){
        vacante.idVacante = null;
        vacante.status = false;
        this.registrarVacante(vacante);
      }
    } catch (error) {
      console.error("Error en duplicar la vacante.", error);
    }
  }


  editarStatusVacante(idVacante: number, status: boolean){
    this.vacantesService.actulizarStatusVacanteEmpresa(idVacante, status).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.abrirModalMessage("Error", "Disculpe las molestias ha ocurrido un error en actualizar la visibilidad de la vacante, por favor de intentarlo más tarde.");
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.ngOnInit();
        this.abrirModalMessage("Éxito", "Se ha actualizado correctamente la visibilidad de la vacante.");
      } else {
        this.abrirModalMessage("Error", "No se ha actualizado la visibilidad del vacante correctamente");
        console.error('Error al actualizar la postulación del vacante de la empresa: ', result.messageError);
      }
    });
  }

  redirigirUrl(url: string): void{
    const isUrl = /^http[s]?/;
    if(!isUrl.test(url)){
      url = 'https://' + url;
    }

    if (isPlatformBrowser(this.platformId)) {
      window.open(url, '_blank');
    }
  }

  scrollToElement($element): void {
    $element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }

  verDetalles(vacante: Vacante){
    localStorage.setItem('idVacante', vacante.idVacante.toString());
    if(localStorage.getItem('idVacante')){
        this.router.navigate(['/vacantes/detalles/'+vacante.urlVacante]);
    }
  }

//   private cambiarFormatoNombreVacante(vacante: string): string {
//     const sinDiacriticos: string = vacante.normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-zA-Z -]/g, "");
//     const resultado: string = sinDiacriticos.trim().split(' ').join('-').toLowerCase();
//     return resultado;
//   }

  abrirModalMessage(modalTitle: string, modalMessage: string) {
    const modalRef = this.modalService.open(ModalMessageComponent, { centered: true });
    modalRef.componentInstance.modalTitle = modalTitle;
    modalRef.componentInstance.modalMessage = modalMessage;
  }

  registrarVacante(vacante: VacanteDTO): void {
    this.vacantesService.crearVacanteEmpresa(this.usuario.user.idUsuario, vacante).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.abrirModalMessage("Error", "Disculpe las molestias ha ocurrido un error en duplicar su vacante.");
        this.duplicando = false;
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.ngOnInit();
        this.abrirModalMessage("Éxito", "Se ha duplicado correctamente la vacante.");
      } else {
        this.abrirModalMessage("Error", "No se ha duplicado correctamente " + result.messageError);
        console.error('Error al duplicar la postulación del vacante de la empresa: ', result.messageError);
      }

      this.duplicando = false;
    });
  }
 
  onImageError(event: Event): void {
    const defaultLogo = 'assets/img/user/empresa-default.png';
    const target = event.target as HTMLImageElement;
    target.src = defaultLogo;
  }

  private mezclarParcialVacantes(vacantes: Vacante[], porcentajeMezcla: number = 0.3): Vacante[] {
  const cantidadMezclar = Math.floor(vacantes.length * porcentajeMezcla);

  const primeras = vacantes.slice(0, cantidadMezclar);
  const restantes = vacantes.slice(cantidadMezclar);


  for (let i = primeras.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [primeras[i], primeras[j]] = [primeras[j], primeras[i]];
  }

  return [...primeras, ...restantes];
}

  snippetText(desc: string, max = 140): string {
    return (desc || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().substring(0, max);
  }

}
